import { render, staticRenderFns } from "./LomSubscriptionList.vue?vue&type=template&id=22743036"
import script from "./LomSubscriptionList.vue?vue&type=script&lang=js"
export * from "./LomSubscriptionList.vue?vue&type=script&lang=js"
import style0 from "./LomSubscriptionList.vue?vue&type=style&index=0&id=22743036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports